import { FARM_CREDIT_CLIENTS, getConfig } from '@/features/environment/config';

export interface UseClientNameReturn {
  clientName: string | undefined;
  isLiaFcs: boolean;
}

export const useClientName = (): UseClientNameReturn => {
  const clientName = getConfig()?.CLIENT_NAME;
  const isLiaFcs = FARM_CREDIT_CLIENTS.has(clientName ?? '');

  return { clientName, isLiaFcs };
};
